module.exports = __webpack_public_path__ + "media/images/bg/patterns/clouds-dc73db2161dfcbf13bcad44dda711e6e.svg";